import { Subscription } from "rxjs";
import { Cuota } from "./Cuota";
import { DatosClaveCuota } from "./DatosClaveCuota";
import { TagDTO } from "@DTOS";

export class DatosCuotas {
    public titulo = "";
    public datosClaves: DatosClaveCuota[] = [];
    public cuotas: { [key: number]: Cuota } = {};
    public cuotasActivas = false;

    public controlTags?: (tags: TagDTO[]) => Promise<TagDTO[]>;

    private _cantidadMaxima = 0;
    private subscriptionCuotas = new Subscription();

    constructor(datosClaves: DatosClaveCuota[], titulo: string, cantidadMaxima: number) {
        this.datosClaves = datosClaves;
        this.titulo = titulo;
        this._cantidadMaxima = cantidadMaxima;

        const claves = this.datosClaves.map(dato => dato.clave);
        claves.forEach((clave, index) => {
            this.cuotas[clave] = new Cuota(0, false, this.datosClaves[index].tag);

            this.subscriptionCuotas.add(
                this.cuotas[clave].cambioActivado.subscribe(hayQueCalcularDatos =>
                    hayQueCalcularDatos ? this.recalcularDatos() : null)
            );
        });
    }

    public get cantidadMaxima() {
        return this._cantidadMaxima;
    }

    public set cantidadMaxima(cantidad: number) {
        this._cantidadMaxima = cantidad;
        this.recalcularDatos();
    }

    public recalcularDatos() {
        const cuotasActivas = Object.keys(this.cuotas).filter(cuotaClave =>
            this.cuotas[parseInt(cuotaClave, 10)].activado);
        if (cuotasActivas.length > 0) {
            const cantidadBase = Math.trunc(this.cantidadMaxima / cuotasActivas.length);

            cuotasActivas.forEach(clave => {
                this.cuotas[clave].valor = cantidadBase;
            });

            if (this.cantidadMaxima % cuotasActivas.length !== 0) {
                this.cuotas[0].valor += this.cantidadMaxima % cuotasActivas.length;
            }
        }
    }

    public limpiarSubscriptions() {
        this.subscriptionCuotas.unsubscribe();
    }
}
